export const adminProfileKeys = {
  base: ["adminProfile"] as const,
  details: () => [...adminProfileKeys.base, "details"] as const,
  detailsById: (id: string) => [...adminProfileKeys.base, id, "details"] as const,
  practiceList: () => [...adminProfileKeys.base, "practiceList"] as const,
} as const;
